import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//import { DragulaService } from 'ng2-dragula';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import * as dto from "../models/dashboard.dto";
import * as model from "../models/dashboard.model";
import { SubHeader } from "../../core/models/sub-header.model";
import { DashboardLayoutKind } from "../models/dashboard.dto";

import { DashboardService } from "../services/dashboard.service";
import { LoaderService } from "../../common/services/loader.service";
import { SubHeaderService } from "../../core/services/sub-header.service";

import { SidePanel } from "../../common/models/side-panel.model";

import { SidePanelService } from "../../common/services/side-panel.service";

function initLayoutClassMatrix() {
    let result = {};
    result[DashboardLayoutKind.ThreeColumn] = ["medium-3", "medium-3", "medium-3"];
    result[DashboardLayoutKind.TwoColumnRightLarge] = ["medium-4", "medium-8"];
    result[DashboardLayoutKind.TwoColumnLeftLarge] = ["medium-8", "medium-4"];
    result[DashboardLayoutKind.TwoColumnEqual] = ["medium-6", "medium-6"];
    result[DashboardLayoutKind.SingleColumn] = ["medium-12"];
    return result;
}

@Component({
    selector: 'edit-dashboard',
    templateUrl: './edit-dashboard.component.html',
    styleUrls: ['./view-dashboard.component.scss', './edit-dashboard.component.scss'],
    standalone: false
})

export class EditDashboardComponent implements OnInit {
    public _layoutClassMatrix;

    public dashboard: dto.Dashboard;
    public selectedColumn: number;
    public subHeader: SubHeader;
    public title: string;
    public dashboardRef: dto.Dashboard;

	public sidePanel: SidePanel;

	get columnDropListIds(): string[] {
		return this.dashboard?.columns?.map((_, i) => `column-${i}`) || [];
	}

    constructor(public dashboardService: DashboardService,
        public route: ActivatedRoute,
        public router: Router,
        public loaderService: LoaderService,
        public subHeaderService: SubHeaderService,
        public sidePanelService: SidePanelService
	) {

        this._layoutClassMatrix = initLayoutClassMatrix()
    }

    ngOnInit() {
        this.dashboardRef = this.route.snapshot.data.dashboard;
        this.dashboard = this.route.snapshot.data.dashboard;
        this.sidePanel = new SidePanel({
            tabs: [{ title: "Add View" }],
            sections: [{ componentName: 'addnewwidget', data: this.dashboard.columns, method: (w) => this.onAddWidget(w) }],
            visible: false
        });
        this.title = this.dashboard.title;
        this.loaderService.toggleLoader(false);

        //update subheader
        this.subHeader = new SubHeader({
            title: this.title,
            buttons: [
                { name: "Save", method: () => this.save() },
                { name: "Cancel", method: () => this.cancel() },
                { name: "Reset", method: () => this.reset() }
            ]
        });

        this.subHeaderService.updateSubHeader(this.subHeader);

        this.sidePanelService.newSidePanel(this.sidePanel);
    }

    public cancel(): void {
        //TODO are you sure?? message
        this.router.navigate(['/dashboard/view', this.dashboard.id]);
    }

    public delete(w): void {
        const d = model.Dashboard.createFrom(this.dashboard);
        d.deleteWidget(w);
        this.dashboard = d;
    }

    public reset(): void {
        this.dashboard = this.dashboardRef;
    }

    public getLayout(columnIndex: number): string {
        const columnLayouts = this._layoutClassMatrix[this.dashboard.layout];

        if (columnLayouts) {
            if (columnLayouts[columnIndex]) {
                return columnLayouts[columnIndex];
            }
        }

        return "medium-12";
    }

    public onAddWidget(w): void {
        const d = model.Dashboard.createFrom(this.dashboard);
        d.addWidget(w, this.selectedColumn);
        this.dashboard = d;

        this.sidePanelService.toggleSidePanel(false);
	}

	public onWidgetDrop(event: CdkDragDrop<any[]>, columnIndex: number): void {
		if (event.previousContainer === event.container) {
			moveItemInArray(this.dashboard.columns[columnIndex], event.previousIndex, event.currentIndex);
		} else {
			const prevColIndex = this.dashboard.columns.findIndex(col => col === event.previousContainer.data);
			transferArrayItem(
				this.dashboard.columns[prevColIndex],
				this.dashboard.columns[columnIndex],
				event.previousIndex,
				event.currentIndex
			);
		}
	}

    public save(): void {
        this.dashboardService.post(this.dashboard).subscribe(results => {
            //TODO message that dashboard has been saved
            this.router.navigate(['/dashboard/view', this.dashboard.id]);
        },
            error => {
                console.error(error);
                //TODO message that dashboard was not saved
            });
    }

    public toggleMenu(index): void {
        this.selectedColumn = index;
        let widgets: dto.Widget[] = [];

        for (let column of this.dashboard.columns)
            for (let widget of column)
                widgets.push(widget);

        this.sidePanel.sections.find(x => x.componentName === 'addnewwidget').data = widgets;
        this.sidePanelService.toggleSidePanel(true);
    }

    //public setupDragula(): void {
    //    if (this._dragulaService.find('widget-column'))
    //        return;

    //    this._dragulaService.createGroup('widget-column',
    //        {
    //            removeOnSpill: false,
    //            moves: function (el, container, target) {
    //                return target.closest('.handle') !== null;
    //            }
    //        }
    //    );
    //}
}
